import { Link } from "react-router-dom";

export default function NotFound() {
  return (
    <section style={{ padding: "140px 0" }}>
      <div className="wrap center">
        <div className="eyebrow">404</div>
        <h1 style={{ color: "var(--white)", marginTop: 18 }}>Page not found.</h1>
        <p className="sub" style={{ margin: "18px auto 36px" }}>
          The page you are looking for has moved or no longer exists.
        </p>
        <Link className="btn btn-primary" to="/">Return home</Link>
      </div>
    </section>
  );
}
